module.exports = "<p>\n  feature-request works!\n</p>\n"